import { useNavigate } from "react-router-dom";
import LogoHeader from "../Components/LogoHeader/LogoHeader";
import { INDEX_MASTER_PATH, INDEX_PLAYER_PATH } from "../Services/routeNames";
import './layout.scss';

type HeaderProps = {
    currentPage: string
    children: any;
    hamburger: boolean;
    isMaster?: boolean;
    isPlayer?: boolean;
}

function HeaderLayout(props: HeaderProps) {
    const navigate = useNavigate();

    return (
        <div className="header-layout">
            <LogoHeader />

            <div className="title" onClick={() => navigate(props.isMaster ? INDEX_MASTER_PATH : props.isPlayer ? INDEX_PLAYER_PATH : '/')}>
                <img src="/image/layout/panneau-titre-marron.png" alt="fond" />
                <div className="title-text">
                    {props.children}
                </div>
            </div>
        </div>
    );
}

export default HeaderLayout;